module.exports = __webpack_public_path__ + "img/p7-p1-bg.0606e607.jpg";